_getSessionDetails